import { FC } from "react";

const HorizontalPaddingWrapper: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="px-container-mobile md:px-container-desktop">{children}</div>;
}

export default HorizontalPaddingWrapper;
